/**
 * Custom PrimeNG Aura Theme Preset for M&D Insights Dashboard
 * Based on BrandRA design tokens from Figma
 */

// PrimeNG 21 deprecates `@primeng/themes` in favor of `@primeuix/themes`
// (the underlying shared theming package). The two have identical APIs;
// this is a backward-compatible import-path swap.
import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

export const CustomAuraPreset = definePreset(Aura, {
  // Define semantic tokens using our BrandRA colors directly
  semantic: {
    primary: {
      50: '#f0f9ff',
      100: '#e0f2fe',
      200: '#bae6fd',
      300: '#89c4ff', // brandRA/300 - Navigation text
      400: '#60a5fa',
      500: '#0b3ef9', // brandRA/600 - Changed from default to our brand primary
      600: '#0929cc', // Darker shade of brandRA/600
      700: '#1d4ed8',
      800: '#1e40af',
      900: '#101d91', // brandRA/900 - Navigation background
      950: '#0c1e3d',
    },

    // Color scheme specific overrides - this should handle most component styling
    colorScheme: {
      light: {
        primary: {
          color: '#0b3ef9',
          contrastColor: '#ffffff',
          hoverColor: '#1638c4',
          activeColor: '#122ca9',
        },
        highlight: {
          background: '#e9f5ff',
          focusBackground: '#d6eeff',
          color: '#1638c4',
          focusColor: '#122ca9',
        },

        // Surface colors - critical for navigation background
        surface: {
          0: '#ffffff',
          50: '#fafafa',
          100: '#f5f5f5',
          200: '#eeeeee',
          300: '#e0e0e0',
          400: '#bdbdbd',
          500: '#9e9e9e',
          600: '#757575',
          700: '#616161',
          800: '#424242',
          900: '#101d91', // brandRA/900 - This should be used by dark components
          950: '#0c1e3d',
        },
      },
      dark: {
        primary: {
          color: '#3575ff',
          contrastColor: '#101d91',
          hoverColor: '#b5dcff',
          activeColor: '#d6eeff',
        },
        highlight: {
          background: 'rgba(11, 62, 249, .16)', // 0B3EF9 @16%
          focusBackground: 'rgba(11, 62, 249, .24)',
          color: 'rgba(255,255,255,.87)',
          focusColor: 'rgba(255,255,255,.87)',
        },
        // Use Aura's default dark surfaces so dark mode backgrounds are neutral,
        // not brand-colored. This enables proper .p-dark switching.
      },
    },
  },
});
